
angular.module('mtic.components.login').directive('sessionExpiryModal', function (EventManager, $location, $log, userAccount,$timeout) {
      return {
            templateUrl: 'template.html',
            restrict: 'E',
            scope: {},
            link: function (scope) {
                  var eventManager = new EventManager('sessionExpiryModal',scope);
                  scope.isOpen = false;
                  window.session_out = function(){
                      scope.isOpen = true;
                      scope.$digest();
                  }
                  eventManager.listen('login:session:expired', function (message) {
                        window.focus();
                        scope.isOpen = true;
                        scope.username = userAccount.getData().uuid;
                        if(message) {
                              scope.doNotStayOnMainPage = true;
                        }
                  })
                  eventManager.listen('session-expiry:close', function () {
                        scope.isOpen = false;
                        scope.doNotStayOnMainPage = false;
                  })
                  eventManager.listen('login:first', function (message) {
                        scope.isOpen = false;
                        scope.doNotStayOnMainPage = false;
                  })

                  scope.close = function () {
                        scope.isOpen = false
                        eventManager.broadcast('logout')
                  }
                  scope.currentDisplay = function () {
                        return scope.isOpen ? 'flex' : 'none';
                  }
            }
      }

})
